<template>
  <div v-if="datos" class="flex flex-col justify-center h-auto">
    <div class="w-full">
      <div
        class="w-full h-auto bg-no-repeat bg-cover bg-bono-gipuzkoa ie11_only safari_only"
      >
        <div
          class="flex flex-wrap-reverse justify-between max-w-screen-xl px-5 pt-12 pb-12 mx-auto text-white align-middle"
        >
          <div class="flex flex-col justify-center w-full md:max-w-screen-md">
            <div class="flex w-full max-w-screen-sm py-3 text-3xl font-bold">
              <img :src="datos.banner" alt="banner" class="w-full" />
            </div>
            <p
              class="text-lg tracking-tight text-justify lg:text-left"
              v-html="$t('Hero 01')"
            >
              {{ $t("Hero 01") }}
            </p>
            <div
              class="mt-5 text-sm font-semibold text-color-accent hover:text-color-accent"
            >
              <div v-if="$t('activar_zoom') == 'S'">
                <a
                  :href="enlaceExterno"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="block w-full p-1 text-xl font-bold text-center text-white rounded bg-color-accent"
                >
                  {{ $t("texto_zoom") }}
                </a>
              </div>

              <div class="flex justify-between w-full">
                <VDialog
                  no-scroll
                  v-model="ventanaMapa"
                  transition="slide-right"
                  bg-transition="fade"
                  :classes="{ bg: 'bg-blue-900', content: 'bg-gray-200' }"
                >
                  <template #toggle="{ bind, on }">
                    <button
                      class="mt-5 text-sm font-semibold text-color-accent hover:text-color-accent"
                      v-bind="bind"
                      v-on="on"
                    >
                      {{ $t("Más información") }}...
                    </button>
                  </template>
                  <div
                    v-if="contenidoActual"
                    class="max-w-screen-lg w-96 md:w-full"
                  >
                    <div class="w-full px-5 my-3 text-right">
                      <button
                        class="text-md"
                        @click.prevent="ventanaMapa = !ventanaMapa"
                      >
                        {{ $t("Cerrar") }}
                      </button>
                    </div>
                    <div
                      @cerrar="cerrarVentana"
                      ventana="ventanaMapa"
                      class="w-full h-auto lg:max-w-screen-lg"
                    >
                      <div class="w-full px-5 pb-5 uppercase">
                        {{ $t("Más información") }}
                      </div>
                      <div
                        class="px-5 pb-5 mb-5 overflow-y-scroll h-128"
                        v-html="contenidoActual"
                      ></div>
                    </div>
                  </div>
                </VDialog>
              </div>
            </div>
            <div class="block md:flex">
              <div
                class="px-5 pb-1 mt-5 mr-5 bg-white rounded-full shadow-md hover:bg-color-accent hover:text-color-accent hover:shadow-xl"
              >
                <router-link :to="`/${$i18n.locale}/bono/araba`">
                  <img
                    class="h-10"
                    src="https://firebasestorage.googleapis.com/v0/b/jmdb-production.appspot.com/o/establecimientos%2Flogos%2Fhash%2Falava.svg?alt=media&token=31c50840-03be-499d-9b83-6b086279f65f"
                    alt="imagen"
                  />
                </router-link>
              </div>
              <div
                class="px-5 pb-1 mt-5 mr-5 bg-white rounded-full shadow-md hover:bg-color-accent hover:text-color-accent hover:shadow-xl"
              >
                <router-link :to="`/${$i18n.locale}/bono/bizkaia`">
                  <img
                    class="h-10"
                    src="https://firebasestorage.googleapis.com/v0/b/jmdb-production.appspot.com/o/establecimientos%2Flogos%2Fhash%2Fbizkaia.svg?alt=media&token=aade5802-9f05-45ed-ab98-aaf3f989ab00"
                    alt="imagen"
                  />
                </router-link>
              </div>
              <div
                class="px-5 pb-1 mt-5 mr-5 bg-white rounded-full shadow-md hover:bg-color-accent hover:text-color-accent hover:shadow-xl"
              >
                <router-link :to="`/${$i18n.locale}/bono/gipuzkoa`">
                  <img
                    class="h-10"
                    src="https://firebasestorage.googleapis.com/v0/b/jmdb-production.appspot.com/o/establecimientos%2Flogos%2Fhash%2Fgipuzkoa.svg?alt=media&token=5f60de8d-563f-48ba-bb9e-4630435c855e"
                    alt="imagen"
                  />
                </router-link>
              </div>
            </div>

            <!-- <div class="hidden mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-start">
            <div class="pr-2 mt-3 sm:mt-0">
              <router-link
                :to="`/${$i18n.locale}/establecimientos`"
                class="flex items-center justify-center w-full px-3 py-3 text-base font-medium leading-6 transition duration-150 ease-in-out bg-white border border-transparent rounded-md text-bono-gibg-bono-gipuzkoa hover:text-color-accent focus:outline-none focus:shadow-outline md:py-2 md:text-lg md:px-5"
              >
                {{$t('titulo texto 02')}}
              </router-link>
            </div>
            <div class="mt-3 mr-1 sm:mt-0">
              <router-link
                :to="`/${$i18n.locale}/altas`"
                class="flex items-center justify-center w-full px-8 py-3 text-base font-medium leading-6 text-white transition duration-150 ease-in-out rounded-md hover:bg-bono-gipuzkoa hover:text-color-accent focus:outline-none focus:shadow-outline focus:border-blue-300 md:py-2 md:text-base md:px-3"
              >
                {{$t('Alta comercios')}}
              </router-link>
            </div>

          </div> -->
            <div class="text-xs font-thin text-center">
              {{ $t("parrafo 02") }}
            </div>
          </div>
          <div class="w-full md:w-96">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/jmdb-production.appspot.com/o/establecimientos%2Flogos%2Fimagen_bonos.svg?alt=media&token=19c0c36a-e0fb-44c3-824e-ea2bcc7a6709"
              alt="imagen bonos"
            />
          </div>
        </div>
      </div>
      <div class="w-full bg-transparent">
        <div class="max-w-screen-xl px-6 py-10 mx-auto text-left">
          <div class="mt-5">
            <ul class="md:grid md:grid-cols-3 md:col-gap-8 md:row-gap-10">
              <li>
                <div class="flex">
                  <div class="flex-shrink-0">
                    <div
                      class="flex items-center justify-center w-16 h-16 text-white rounded-full bg-bono-gipuzkoa"
                    >
                      <div class="text-4xl font-bold">01</div>
                      <!-- <svg class="w-6 h-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"/>
                </svg> -->
                    </div>
                  </div>
                  <div class="ml-4">
                    <h5 class="text-lg font-medium leading-6 text-gray-900">
                      {{ $t("titulo texto 01") }}
                    </h5>
                    <p class="mt-2 text-base leading-6 text-gray-500">
                      {{ $t("texto 01") }}
                    </p>
                  </div>
                </div>
              </li>
              <li class="mt-10 md:mt-0">
                <div class="flex">
                  <div class="flex-shrink-0">
                    <div
                      class="flex items-center justify-center w-16 h-16 text-white rounded-full bg-bono-gipuzkoa"
                    >
                      <div class="text-4xl font-bold">02</div>
                      <!-- <svg class="w-6 h-6" stroke="currentColor" fill="currentColor" viewBox="0 0 24 24">
                  <path class="heroicon-ui" d="M2.59 13.41A1.98 1.98 0 0 1 2 12V7a5 5 0 0 1 5-5h4.99c.53 0 1.04.2 1.42.59l8 8a2 2 0 0 1 0 2.82l-8 8a2 2 0 0 1-2.82 0l-8-8zM20 12l-8-8H7a3 3 0 0 0-3 3v5l8 8 8-8zM7 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                </svg> -->
                    </div>
                  </div>
                  <div class="ml-4">
                    <h5 class="text-lg font-medium leading-6 text-gray-900">
                      {{ $t("titulo texto 02") }}
                    </h5>
                    <p class="mt-2 text-base leading-6 text-gray-500">
                      {{ $t("texto 02") }}
                    </p>
                  </div>
                </div>
              </li>
              <li class="mt-10 md:mt-0">
                <div class="flex">
                  <div class="flex-shrink-0">
                    <div
                      class="flex items-center justify-center w-16 h-16 text-white rounded-full bg-bono-gipuzkoa"
                    >
                      <div class="text-4xl font-bold">03</div>
                      <!-- <svg class="w-6 h-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"/>
                </svg> -->
                    </div>
                  </div>
                  <div class="ml-4">
                    <h5 class="text-lg font-medium leading-6 text-gray-900">
                      {{ $t("titulo texto 03") }}
                    </h5>
                    <p class="mt-2 text-base leading-6 text-gray-500">
                      {{ $t("texto 03") }}
                    </p>
                  </div>
                </div>
              </li>
              <!-- <li class="mt-10 md:mt-0">
          <div class="flex">
            <div class="flex-shrink-0">
              <div class="flex items-center justify-center w-16 h-16 text-white bg-indigo-500 rounded-md">
                <svg class="w-6 h-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"/>
                </svg>
              </div>
            </div>
            <div class="ml-4">
              <h5 class="text-lg font-medium leading-6 text-gray-900">Mobile notifications</h5>
              <p class="mt-2 text-base leading-6 text-gray-500">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maiores impedit perferendis suscipit eaque, iste dolor cupiditate blanditiis ratione.
              </p>
            </div>
          </div>
        </li> -->
            </ul>
          </div>
        </div>
        <div
          class="max-w-screen-xl px-5 py-5 mx-auto text-left text-gray-500 lg:px-24"
        >
          <div class="w-full lg:px-1">
            <p>
              {{ $t("parrafo 01") }}
            </p>
            <p class="my-2">
              {{ $t("parrafo 02") }}
            </p>
            <p>
              {{ $t("parrafo 03") }}
            </p>
          </div>
        </div>
        <div class="hidden">
          <ver-establecimientos></ver-establecimientos>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
/* @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {  
 
   .ie11_only{
     background-color:#7D0451;
   }
}
@media screen and (min-color-index:0) and(-webkit-min-device-pixel-ratio:0) 
{ @media {
    .safari_only {  
        background-color:#7D0451; 

    }
}} */
</style>
<script>
import VerEstablecimientos from "@/components/TestoSearch.vue";
import { VDialog } from "vuetensils/src/components";

export default {
  props: ["datos"],
  components: {
    VerEstablecimientos,
    VDialog,
  },
  data() {
    return {
      ventanaMapa: false,
    };
  },
  computed: {
    contenidoActual() {
      const locale = this.$i18n.locale;
      const bonoActual = this.bonoActual ? this.bonoActual : {};
      const componenteActual = "info";
      return bonoActual.contenido
        ? bonoActual.contenido[locale][componenteActual]
        : {};
    },
    imgUrl() {
      return this.$store.state.img1;
    },
    bonoActual() {
      return this.$store.state.bonoActual;
    },
    enlaceExterno() {
      return (
        this.$t("enlace_zoom") + "?Idioma=" + this.$i18n.locale.toUpperCase()
      );
    },
  },
  methods: {
    cerrarVentana(valor) {
      console.log("cerrar ventana", valor);
      this[valor] = false;
    },
  },
};
</script>
